<button class="activity-item"
        [ngClass]="{ 'not-viewed': !notification().ViewDate }"
        (click)="markAsRead($event, btn)"
        #btn>
  <div class="activity-item-header">
    <div class="activity-item-icon">
      <i class="fa-regular fa-gear-complex" aria-hidden="true"></i>
    </div>

    <div>
      <span class="activity-item-title flex-grow-1 d-flex justify-content-between">
        {{ notification().Title }}
        <span class="close-btn" (click)="deleteNotification($event)">
          <i class="fa fa-times" aria-hidden="true"></i>
        </span>

        @if (!notification().ViewDate) {
          <span class="unread-dot"></span>
        }
      </span>

      @if (notification() && notification().CreationDate) {
        <div class="date">
          {{ notification().CreationDate | dateAgo }}
        </div>
      }

      <div class="activity-item-desc">{{ notification().Details }}</div>
    </div>
  </div>
</button>
